import {putAll, showBeError, showSuccess, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {opt} from 'ts-opt';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';

import {adminAction, RemoveUsersFromOtherSubjectRoleAction} from '../action';

const tt = t('admin');

function* execute({payload: {roleId, otherSubjectId}}: RemoveUsersFromOtherSubjectRoleAction): SagaIterator {
    const response = yield* call(Api.endUserProfileOtherSubjectRoleBindingForRole, {roleId, otherSubjectId});

    if (response.isSuccess) {
        yield* put(adminAction.getManagementOtherSubjectsTableData(opt({action: 'refresh'}), opt(otherSubjectId)));
        yield putAll(showSuccess(
            tt('removeUsersFromRole'),
            tt('removeUsersFromRoleSuccess'),
            false,
            'removeUsersFromRole',
        ));
    } else {
        yield putAll(showBeError(response, tt('removeUsersFromRole')));
    }
}

/** Runs the admin saga that removes users from the selected other-subject role. */
export function* removeUsersFromOtherSubjectRole(): SagaIterator {
    yield takeLatestF('admin/REMOVE_USERS_FROM_OTHER_SUBJECT_ROLE', execute);
}
